import React, { useEffect, useRef, useState } from "react";
import "./Banner.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getHomeBanner } from "../../../features/home/homeSlice";

function Banner() {
  const data = [
    "/assets/images/home/banner/b1.png",
    "/assets/images/home/banner/b2.png",
  ];
  const banners = useSelector((state) => state.home.banners);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getHomeBanner());
  }, []);
  return (
    <section className="home_banner_sec">
      <div className="container-fluid p-0">
        <div className="slider_main">
          {/* <Swiper
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
          >
            {banners?.map((val) => (
              <SwiperSlide>
                <div className="sliderdiv">
                  <img
                    className="bannerimg"
                    src={process.env.REACT_APP_IMG_URL + val.image}
                    alt="banner-img"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}

          <Swiper
            spaceBetween={30}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Pagination]}
          >

             {/* <SwiperSlide>
              <div className="sliderdiv">
                <video
                  className="banner_media_video"
                  autoPlay
                  muted
                  loop
                  playsInline
                >
                  <source
                    src="/assets/images/home/video/majestry_video.mp4"
                    type="video/mp4"
                    className="video"
                  />
                </video>
              </div>
            </SwiperSlide> */}
            {banners?.map((val, index) => (
              <SwiperSlide key={index}>
                <div className="sliderdiv">
                  <img
                    className="bannerimg"
                    src={process.env.REACT_APP_IMG_URL + val.image}
                    alt="banner"
                  />
                </div>
              </SwiperSlide>
            ))}

           
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Banner;
